var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticClass:"t2d"},[_c('div',{staticClass:"t2d-page"},[(!_vm.hideAppBar)?_c('SiteHeader'):_vm._e(),_c('main',{staticClass:"t2d-page__body"},[_c('router-view',{key:_vm.$route.path})],1),(!_vm.hideAppBar)?_c('ShareBar'):_vm._e(),(!_vm.hideAppBar)?_c('SiteFooter'):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }